import React, { memo } from 'react';
import {
  useEngineInstance,
  useSubjectId
} from '@surveycake/react-logic-engine';
import { Tag } from '@surveycake/rc';
import { ColorResolver } from '@surveycake/rc';
import { useSurveyConfig } from 'app/core/survey-config';

const colorSelector: ColorResolver = theme => theme.survey.color.default;

/**
 * @description render condition
 * 多選題，重複核選題，若該題沒有設定選項區間上限以及下限時
 * 多選題，重複核選題有設定上限，且上限大於 1 時。
 */
function Label() {
  const engine = useEngineInstance();
  const id = useSubjectId();
  const { lowerbounds, upperbounds } = engine.getSubjectData(id);
  const { wording } = useSurveyConfig();

  if (
    (lowerbounds === null && upperbounds === null) ||
    (upperbounds !== null && upperbounds > 1)
  ) {
    return <Tag color={colorSelector}>{wording.subject.choicemulti.label}</Tag>;
  }

  return null;
}

export default memo(Label);
